import 'css-chunksrc/client/scenes/wbs/task/allocationsList/details/group/styles.scss';export default {
  "group": "_group_14arc_1",
  "removeAllocation": "_removeAllocation_14arc_7",
  "resource": "_resource_14arc_11",
  "container": "_container_14arc_20",
  "label": "_label_14arc_28",
  "center": "_center_14arc_34",
  "avatar": "_avatar_14arc_38",
  "user": "_user_14arc_48",
  "name": "_name_14arc_61",
  "title": "_title_14arc_67",
  "allocatedHours": "_allocatedHours_14arc_72",
  "completionCheck": "_completionCheck_14arc_89",
  "icon": "_icon_14arc_101"
};